export default "__VITE_ASSET__XoSfvSSE__"